import React from "react";
import ReactDOM from "react-dom/client";
import MealMenu from "./App";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<React.StrictMode><MealMenu /></React.StrictMode>);
